// Full-page navigation and reloads, behind functions a spec can mock (PANEL-1542). jsdom 21+ (Jest 30
// runs jsdom 26) makes window.location unforgeable, so specs can no longer swap in a stub object to
// observe a reload or a redirect. Code that only READS the URL keeps using window.location; specs set
// it with history.pushState or the jsdom URL (config/jest/environment.js) — except where a spec has to
// feed a URL no real Location can hold, which is what currentLocation is for.
// Arguments go through untouched: ErrorModal passes Firefox's non-standard `forceGet` (a reload that
// bypasses its HTTP cache; other engines ignore it), and every other caller passes none.
export const reloadPage = (...args) => {
  window.location.reload(...args);
};

// Same as assigning window.location / window.location.href: a full navigation to `url`.
export const goTo = (url) => {
  window.location.href = url;
};

// window.location, read through a function so a spec can hand the caller values a real Location never
// holds (it always normalizes): an href that is not absolute (components/Help's fragment guard) or a
// hostname no URL parser keeps verbatim (serviceWorker's localhost regex). Read-only use only.
export const currentLocation = () => window.location;
